import AVdxbCaptionList from './index.vue';

AVdxbCaptionList.install = app => {
  app.component(AVdxbCaptionList.name, AVdxbCaptionList);
};

export default AVdxbCaptionList;
